var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { connect } from 'react-redux';
import { get, map, defaults, forIn, set, cloneDeep, find } from 'lodash';
import { Table } from '../table';
import { actions } from '@comall-backend-builder/core';
var DEFAULT_PAGE_INDEX = 1;
var DEFAULT_STATE = {
  result: [],
  selectedRowKeys: [],
  sort: {}
};

function mapStateToProps(state, props) {
  var entity = props.entity,
      componentId = props.componentId;
  var component = state.components[componentId];
  var fields = component && component.fields;
  var metainfo = entity.metainfo; // 未配置表单域

  if (!props.columns) {
    throw new Error("Columns not found in Component " + componentId);
  }

  var componentState = __assign({
    metainfo: metainfo,
    requestStatus: entity.requestStatus,
    selectedRowKeys: get(component, 'selectedRowKeys'),
    submitType: component && component.submitType,
    result: entity.result
  }, entity.paging);

  if (fields) {
    componentState.result = map(componentState.result, function (row) {
      if (row.id === fields.id) {
        return __assign(__assign({}, fields), {
          _modify: true
        });
      } else {
        return row;
      }
    });
  }

  componentState.sort = component && component.sort;
  return defaults(componentState, DEFAULT_STATE);
}

function mapDispatchToProps(dispatch, props) {
  var componentId = props.componentId,
      entity = props.entity,
      params = props.params,
      onDeleteItem = props.onDeleteItem,
      onSubmitSuccess = props.onSubmitSuccess;
  return defaults({
    onDeleteItem: onDeleteItem,
    onSubmitSuccess: onSubmitSuccess
  }, {
    // 设置初始分页
    onInit: function onInit() {
      var loaderType = props.loaderType;

      if (loaderType) {
        return;
      }

      if (props.pagination && !entity.paging) {
        var page = get(props, 'pagination.defaultCurrent', DEFAULT_PAGE_INDEX);
        var perPage = get(props, 'pagination.pageSize');
        entity.pageChange({
          page: page,
          perPage: perPage
        });
      }

      if (props.infiniteScroll) {
        var page = get(props, 'infiniteScroll.defaultCurrent', DEFAULT_PAGE_INDEX);
        var perPage = get(props, 'infiniteScroll.pageSize');
        entity.pageChange({
          page: page,
          perPage: perPage
        });
      }

      if (props.loadFirstPage) {
        dispatch(actions.componentSubmitAction(componentId, 'paging'));
        entity.search(params);
      }
    },
    onModifyStart: function onModifyStart(row) {
      dispatch(actions.tableModifyStartAction(componentId, entity, row));
    },
    onModifyConfirm: function onModifyConfirm(row) {
      var fields = {};
      forIn(props.columns, function (column) {
        var modifiable = column.modifiable,
            property = column.property;

        if (modifiable !== false) {
          set(fields, property, get(row, property));
        }
      });

      var requestParams = __assign(__assign({}, params), {
        id: row.id
      });

      dispatch(actions.componentSubmitAction(componentId, 'modify'));
      entity.modify(fields, requestParams, {
        action: actions.tableModifyFinishAction(componentId, entity)
      });
    },
    onModifyCancel: function onModifyCancel(_row) {
      dispatch(actions.tableModifyFinishAction(componentId, entity));
    },
    onModifyChange: function onModifyChange(name, value, row) {
      var fields = cloneDeep(row);
      set(fields, name, value);

      if (props.convertModifyFields) {
        fields = props.convertModifyFields(fields);
      }

      dispatch(actions.tableModifyChangeAction(componentId, entity, fields));
    },
    onRowSelectionChange: function onRowSelectionChange(selectedRowKeys) {
      dispatch(actions.tableRowSelectionChangeAction(componentId, selectedRowKeys));
    },
    // 删除条目
    onDeleteItem: function onDeleteItem(itemId) {
      dispatch(actions.componentSubmitAction(componentId, 'delete'));
      entity.delete(__assign(__assign({}, params), {
        id: itemId
      }));
    },
    // 筛选条件改变
    onChange: function onChange(pagination, _filters, sorter) {
      var page = pagination.current,
          perPage = pagination.pageSize;
      var field = sorter.field,
          order = sorter.order;
      var _a = entity.paging,
          previousPaging = _a === void 0 ? {} : _a,
          _b = entity.filters,
          previousFilters = _b === void 0 ? {} : _b;

      if (page && perPage && (page !== previousPaging.page || perPage !== previousPaging.perPage)) {
        dispatch(actions.componentSubmitAction(componentId, 'paging'));
        entity.pageChange(defaults({
          page: page,
          perPage: perPage
        }, previousPaging));
        entity.search(params);
      } else {
        var sorterFilter = __assign(__assign({}, previousFilters), {
          field: field,
          order: order
        });

        dispatch(actions.tableSortChangeAction(componentId, {
          field: field,
          order: order
        }));
        var column = find(props.columns, {
          property: field
        });

        if (!column) {
          var previousColumn = find(props.columns, {
            property: previousFilters.field
          });

          if (previousColumn && typeof previousColumn.sorter === 'function') {
            return;
          }
        } else if (typeof column.sorter === 'function') {
          return;
        }

        if (field !== previousFilters.field || order !== previousFilters.order) {
          dispatch(actions.componentSubmitAction(componentId, 'paging'));
          entity.filtersChange(sorterFilter);
          entity.pageChange({
            page: 1
          });
          entity.search(params);
        }
      }
    },
    onLoadNextPage: function onLoadNextPage() {
      dispatch(actions.componentSubmitAction(componentId, 'loadNextPage'));
      entity.loadNextPage();
    },
    onSubmitSuccess: function onSubmitSuccess(_result, submitType) {
      if (submitType === 'modify' || submitType === 'delete') {
        entity.search(params);
      }
    },
    onSubmitFinish: function onSubmitFinish() {
      dispatch(actions.componentSubmitFinishAction(componentId));
    }
  });
}

export var DataTable = connect(mapStateToProps, mapDispatchToProps)(Table);